module.exports = __webpack_public_path__ + "img/search-logo.ebc385da.png";